import {AnalyticsService} from "./services/AnalyticsService";
import {GTMConversionEventService} from "./services/GTMConversionEventService";

export default angular.module("tfApp.analytics", [])
                      .service(AnalyticsService.id, AnalyticsService)
                      .service(GTMConversionEventService.id, GTMConversionEventService)
                      .name;
